module.exports = __webpack_public_path__ + "static/media/contenedores-01.2a3cc54c.png";